import { Checkbox } from '@mantine/core';
import React, { useCallback } from 'react';
import { FilterWithOperation, IFilterTagData, TagsFilterProps } from './types';
import CheckIcon from './CheckIcon';

interface TagCheckboxProps {
  hasTag: boolean;
  tag: IFilterTagData;
  onTagFilterChange: TagsFilterProps['onTagFilterChange'];
}
export function TagCheckbox(props: TagCheckboxProps) {
  const { hasTag, tag, onTagFilterChange } = props;
  const onTagCheck = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      let action = 'ADD';
      if (!e.currentTarget.checked) {
        action = 'REMOVE';
      }
      const withAction = [tag, action] as FilterWithOperation;
      onTagFilterChange(withAction);
    },

    [tag, onTagFilterChange],
  );

  return <Checkbox checked={hasTag} onChange={onTagCheck} icon={CheckIcon} />;
}
